import { DEFAULT_PAGE_LIMIT } from 'utils/constants';
import httpClient from '../../httpClient';

export const createNewUser = (data) => {
  return httpClient({
    method: 'POST',
    url: '/super-admin/users/create',
    data,
  });
};

export const getIndividualUser = (userId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/users/${userId}`,
  });
};

export const updateUserPassword = (userId, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/users/${userId}/password/save`,
    data,
  });
};

export const searchUsers = (
  searchInput,
  pageNumber = 0,
  limit = DEFAULT_PAGE_LIMIT,
  sortBy,
  sortOrder,
) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/users/all/search',
    params: {
      searchTerm: searchInput,
      limit,
      pageNumber: pageNumber + 1,
      sortBy,
      sortOrder,
    },
  });
};

export const updateIndividualValueForUser = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/users/${id}/update`,
    data,
  });
};

export const assignUserToBusiness = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/users/${id}/business/update`,
    data,
  });
};

export const assignInstallerToBusinessAndStore = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/users/${id}/installer/stores/update`,
    data,
  });
};

export const editEmployeeCode = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/users/${id}/employee-code/update`,
    data,
  });
};

export const fetchActorToken = (userId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/users/${userId}/actor-token`,
  });
};
